import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup } from "@angular/forms";
import { TPVServices } from "../services";
import { IncomeExpensesServices } from "../../income-expenses/services";
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';

/**
 * Generated class for the TpvCashInoutCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-cash-inout-create',
  templateUrl: 'tpv-cash-inout-create.html',
})
export class TpvCashInoutCreatePage {

  type: any = "";
  public form: FormGroup;
  cash_uid: any;
  cashs = [];
  private firestore: any;
  update_state: boolean;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public tpvServices: TPVServices,
    public incomeExpensesServices: IncomeExpensesServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public translate: TranslateService,
  ) {
    this.firestore = firebase.firestore();
    this.cash_uid = this.navParams.get('cash_uid');
    this.form = fb.group({
      amount: [0],
      concept: [''],
      selected_cash: ['']
    });
    this.update_state = false;

    if (!this.cash_uid) {
      this.getCashs();
      this.cash_uid = null;
      this.update_state = true;
    }

  }

  select(type) {
    this.type = type;
  }

  selected() {
    this.type = "";
  }

  checkState(type) {
    if (this.type == type) {
      return true
    } else {
      return false
    }
  }

  async submit() {
    if (this.type != '' && this.cash_uid && this.form.value.concept != '') {
      var cash = await this.tpvServices.getCash(this.cash_uid);
      var date = new Date();

      if (this.type == 'in') {

        this.inout(cash, date, this.type);

      } else {
        //cash + gasto(IG)
        this.inout(cash, date, this.type);
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-selecciona-opciones-para-guardar'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  inout(cash, date, type) {

    var _inout = {
      type: type,
      concept: this.form.value.concept,
      date: date,
      amount: this.form.value.amount,
    };


    if (!cash.history) {
      var history = [];
      history.push(_inout);
    } else {
      history = cash.history;
      history.push(_inout);
    }

    this.incomeExpensesServices.afs.collection('cashs/' + this.cash_uid + '/history').add({
      'type': type,
      'concept': this.form.value.concept,
      'date': date,
      'amount': this.form.value.amount,

    }).then(doc => {
      this.globals.GAtrackView('TPV', 'TPV - ' + type + ' cash - Create', this.globals.restaurant.email, 'Create/Update', 'Create ' + type + ' cash', 'TPV', '');
      if (type == 'in') {
        this.navCtrl.pop();
      } else {
        //insertar gasto
        this.insertExpenses(date);
      }
    });

    /*this.tpvServices.afs.collection('cashs').doc(cash.UID).update({
      'history': history,
    }).then(() => {
      this.globals.GAtrackView('TPV', 'TPV - ' + type + ' cash - Create', this.globals.restaurant.email, 'Create/Update', 'Create ' + type + ' cash', 'TPV', '');
      if (type == 'in') {
        this.navCtrl.pop();
      } else {
        //insertar gasto
        this.insertExpenses(date);
      }

    });*/
    if (!this.globals.connection) {
      this.navCtrl.pop();
    }
  }

  insertExpenses(date) {
    this.incomeExpensesServices.afs.collection('expenses').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'number': '',
      'date': date,
      'concept': this.form.value.concept,
      'base': this.form.value.amount,
      'tax': 0,
      'total': this.form.value.amount,
      'business_name': '',
      'payment_method': 'efectivo',
      'irpf_percentage': 0,
      'irpf_amount': 0


    }).then(doc => {
      this.navCtrl.pop();
    });
  }
  setCash() {
    if (this.form.value.selected_cash) {
      this.cash_uid = this.cashs.find(x => x.name == this.form.value.selected_cash).UID;
    }
  }

  async getCashs() {
    const publickeyRef = this.firestore.collection('cashs');
    //recuperar public key en firestore con la private
    await publickeyRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).orderBy('number', 'desc').get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var _doc = doc.data()
          _doc.UID = doc.id
          this.cashs.push(_doc);
        });
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-cash-inout-create/tpv-cash-inout-create.ts